import './card.scss';

import { useContext, useEffect } from 'react';

import Abilities from 'components/layouts/card/abilities/abilities';
import Profile from 'components/layouts/card/profile/profile';
import {Resizable} from 're-resizable';
import Rules from 'components/layouts/card/rules/rules';
import { SettingsContext } from 'context/context';
import UniqueActions from 'components/layouts/card/unique_actions/unique_actions';
import Weapons from 'components/layouts/card/weapons/weapons';

function Card({ info }) {
  const { state } = useContext(SettingsContext);

  return (
    <Resizable className="card">
      <Profile info={info} />
      <Weapons weapons={info.weapons} weaponsList={info.weaponsList} />
      <div className={`list ${state.cardOrientation === 'horizontal' ? 'split' : ''}`}>
        { info.abilities.length > 0 ? <Abilities unit_abilities={info.abilities} /> : null }
        { info.uniqueActions.length > 0 ? <UniqueActions actions={info.uniqueActions} /> : <div className="empty-placeholder"><h4>&nbsp;</h4></div> }
      </div>
      <Rules rules={info.rules} />
      <div className="keywords">
      { info.keywords.primary ? <span dangerouslySetInnerHTML={{__html: info.keywords.primary}}></span> : null }
          ,&nbsp;
        <span dangerouslySetInnerHTML={{__html: info.keywords.secondary.map((category) => (category)).join(', ')}}></span>
      </div>
    </Resizable>
  );
}

export default Card;
